import { useState } from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { useSelector } from 'react-redux'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import FaxIcon from '@mui/icons-material/Fax';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import parse from 'html-react-parser';
import { ListSubheader, Avatar, ListItemAvatar, ListItemText, ListItem, List, Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
const StoreSlider = () => {
  var Storeclicked = useSelector(state => state.Storeclicked);
    if ( Storeclicked.clicked ) {
        var settings = {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 3,
        };
        return(<Slider {...settings}>
        {Storeclicked.data.metadata.gallery.map(( image, index ) => {
          return <div className="rsl_slider_image" key={index}><img src={image} width="150" alt="slider" /></div>
        })}
        </Slider>
        )
    }
}
const RoutesList = () => {
  var SiteData = useSelector(state => state.SiteData);
  var directionData = useSelector(state => state.MapDirectionData)
  const [expanded, setExpanded] = useState(false)
  const AccordionhandleChange = ( panel ) => ( event, isExpanded ) => { setExpanded(isExpanded ? panel : false); };
  if ( undefined !== directionData ) {
    var steps = directionData.routes[0].legs[0].steps
    return (
      <Accordion className="rslRouteSteps" expanded={expanded === 'panel1'} onChange={AccordionhandleChange('panel1')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Typography component="span" sx={{ width: '100%', flexShrink: 0 }}>
              <Stack direction="row" spacing={1}>
                <span>{SiteData.label_dist_duration ? SiteData.label_dist_duration : 'Distance & Duration'}</span>
                <Chip label={directionData.routes[0].legs[0].distance.text} size="small" color="primary" variant="outlined" />
                <Chip label={directionData.routes[0].legs[0].duration.text} size="small" color="success" />
              </Stack>
            </Typography>
        </AccordionSummary>
        <AccordionDetails>
            <div className="rsl_route_steps">{steps.map(( step, index ) => {
              return (
                <div className="rsl_route_step" key={index}>
                  <Typography component={'span'} variant="body2" gutterBottom>
                      {parse(step.instructions)}
                  </Typography>
                  <Stack direction="row" spacing={1} style={{float:'right', marginTop:'5px'}}>
                    <Chip label={step.duration.text} size="small" color="primary" variant="outlined" />
                    <Chip label={step.distance.text} size="small" color="success" />
                  </Stack>
                </div>
              )
            } )}</div>
        </AccordionDetails>
    </Accordion>
    )
  }
}
const TimingAccordion = () => {
  var SiteData = useSelector(state => state.SiteData);
  var Storeclicked = useSelector(state => state.Storeclicked)
  const [expanded, setExpanded] = useState(false)
  const AccordionhandleChange = ( panel ) => ( event, isExpanded ) => {
      setExpanded(isExpanded ? panel : false);
  };
  function timeConvert( time ) {
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    var am_label = SiteData.label_am ? SiteData.label_am : 'AM';
    var pm_label = SiteData.label_pm ? SiteData.label_pm : 'PM';
    if ( time.length > 1 ) { // If time format correct
      time = time.slice (1);  // Remove full string match value
      time[5] = +time[0] < 12 ? am_label : pm_label; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
  }
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const current = new Date();
  const day = current.getDay();
  var storetiming;
  var timingdata;
  const weeklySchedules = days.map(( weekday, ind ) => {
    timingdata = Storeclicked.data.metadata.schedule[weekday];
    if ( 'yes' === timingdata.enable ) {
      var from;
      var to;
      storetiming = timingdata.schedule.map( ( timing, index ) => {
        if ( '' === timing.from ) {
          return false;
        }
        from = timing.from;
        to = timing.to;
        if ( '12' === SiteData.timingformat ) {
          from = timeConvert(from);
          to = timeConvert(to);
        }
        return <li key={index} style={{marginLeft:'10px'}}>
          <span>{from} - {to}</span> 
        </li>
      });
      return <span key={ind}>{weekday}
        {storetiming}
      </span>
    }
  });
    return (
      <div className="rslTimingAccordion">
        <Accordion expanded={expanded === 'panel1'} onChange={AccordionhandleChange('panel1')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
              <Typography sx={{ width: '33%', flexShrink: 0 }}>
              {SiteData.label_timing ? SiteData.label_timing : 'store timing'}
              </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography component="span" sx={{ width: '100%', flexShrink: 0 }}><List>{weeklySchedules}</List></Typography>
          </AccordionDetails>
        </Accordion>
    </div>
    )
  }
const StoreMisc = () => {
  var SiteData = useSelector(state => state.SiteData);
  var Storeclicked = useSelector(state => state.Storeclicked);
  const titleColor = SiteData.sidebar_stores_title_color ? SiteData.sidebar_stores_title_color : '#000';
  return (
    <div className="storedetails">
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
         subheader={
          <ListSubheader component="div" id="nested-list-subheader" style={{color:titleColor}}>
            {Storeclicked.data.title.rendered}
          </ListSubheader>
        } >
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <MailIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={Storeclicked.data.metadata.email} />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <LocationOnIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={Storeclicked.data.metadata.fulladdress} />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <FaxIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={Storeclicked.data.metadata.fax} />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
              <PublicIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={Storeclicked.data.metadata.website} />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
              <PhoneIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={Storeclicked.data.metadata.phone} />
          </ListItem>
        </List>
    </div>
  )
}
export { StoreSlider, TimingAccordion, StoreMisc, RoutesList }